import { Star, BadgeCheck } from "lucide-react";

const reviews = [
  { name: "Marisol R.", job: "Debris Removal" },
  { name: "Daniel K.", job: "Property Turnover" },
  { name: "Stephanie A.", job: "Hauling & Cleanup" },
  { name: "Andre P.", job: "Final Detail" },
].map((r, i) => ({
  ...r,
  quote: [
    "Fast, professional, left everything clean.",
    "One call and the turnover was done right.",
    "Showed up on time. Hauled it all. No mess.",
    "Cleanest finish work I've had on a property.",
  ][i],
  initials: r.name.split(" ").map((p) => p[0]).join(""),
}));

export const Reviews = () => {
  return (
    <section id="reviews" className="section-pad bg-charcoal-soft text-warm-white">
      <div className="container-tight">
        <div className="max-w-2xl">
          <span className="eyebrow">Trust Engine</span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl text-warm-white">
            What Clients <span className="text-brass">Say.</span>
          </h2>
        </div>
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {reviews.map((r) => (
            <figure
              key={r.name}
              className="flex h-full flex-col border border-warm-white/10 bg-charcoal p-7 transition-all duration-500 hover:border-brass/60 hover:-translate-y-1"
            >
              <div className="flex gap-1 text-brass">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <blockquote className="mt-5 flex-1 text-base leading-relaxed text-warm-white/85">
                &ldquo;{r.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-warm-white/10 pt-4">
                <div className="flex h-9 w-9 items-center justify-center rounded-full border border-brass/50 text-xs font-display tracking-wider text-brass">
                  {r.initials}
                </div>
                <div className="flex-1">
                  <div className="font-display tracking-wide text-warm-white text-sm">— {r.name}</div>
                  <div className="mt-1 inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] text-brass">
                    <BadgeCheck className="h-3 w-3" strokeWidth={2} />
                    Verified · {r.job}
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
